import { ToasterService } from './../../app/services/toaster.service';
import { Component, OnInit, ElementRef, Renderer2, HostListener, Host } from '@angular/core';
import { ToolbarDirective } from '../../utils/directives/styles/toolbar.directive';
import { Router } from '@angular/router';
import { GlobalUtilService } from '../services/global-util.service';
import { environment } from 'environments/environment';
import { AutobackupService } from '@otas/stoda-settings/stoda-settings/autobackup/autobackup.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[toolbar],toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css'],
    providers: [ToolbarDirective],
    standalone: false
})
export class ToolbarComponent implements OnInit {

  obj: any;

  constructor(
    @Host() private toolbar: ToolbarDirective,
    private router: Router,
    private globalUtilService: GlobalUtilService,
    private autobackupService: AutobackupService,
    public toast: ToasterService
  ) {}

  ngOnInit() {
    this.obj = sessionStorage.getItem('CURRENT_USER') ? JSON.parse(sessionStorage.getItem('CURRENT_USER')) : null;
  }

  @HostListener('document:click', ['$event'])
  outsideClick(event: Event) {
    const target = event.target as HTMLElement;
    // Cancel the default ONLY for ''/'#…' anchors (the stray legacy links and
    // theme fragment toggles this handler was masking; a hash change would also
    // re-trigger the router under onSameUrlNavigation:'reload'). A blanket
    // preventDefault here cancelled the native pre-click toggle of every
    // checkbox/radio in the app — the browser reverts the state and never fires
    // 'change', so formControlName/(change) checkboxes were dead on every
    // screen under this shell.
    const anchor = target.closest ? target.closest('a') : null;
    if (anchor) {
      const href = anchor.getAttribute('href');
      if (href === '' || (href && href.startsWith('#'))) {
        event.preventDefault();
      }
    }
    if (target.closest('.btn-wishlist')) {
      return;
    } else if (!target.closest('.toolbar')) {
      this.toolbar.closeAll();
      this.obj = sessionStorage.getItem('CURRENT_USER') ? JSON.parse(sessionStorage.getItem('CURRENT_USER')) : null;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification(event: Event) {
    if (environment.production && this.globalUtilService.isTauriApp) {
      this.logOut();
    }
  }

  logOut() {
    sessionStorage.clear();
    this.router.navigate(['login-stoda']);
  }

  settings() {
    this.router.navigate(['app/settings/stoda-settings']);
  }

  async onlineSynchronization() {
    this.toast.warning('Please Wait ', 'Processing !!!!!!!!');
    try {
      const s = await this.autobackupService.onlineSynchronization();
      if (s?.result?.length) {
        this.toast.success(`${s.result.length} bookings synchronised successfully`, 'Success');
      } else {
        this.toast.info('No booking available', 'Info');
      }
    } catch (err) {
      this.toast.error(err.message, 'Failed');
    }
  }
}
